import { NgModule } from '@angular/core';

import { TableHeaderSortComponent } from './table-header-sort.component';
import { TableComponent } from './table.component';
import { TableCellDirective, TableRowClickableDirective } from './table.directives';

const EXPORTED = [TableComponent, TableHeaderSortComponent, TableRowClickableDirective, TableCellDirective];

@NgModule({
  imports: [...EXPORTED],
  exports: [EXPORTED],
})
export class SbTableModule {}
